import React from 'react';
import House from '/images/dashboard-page/house.svg';
import { copyFor } from 'config';
import { Container } from 'styles';
import { convertKwhToEquivalent } from './energy-equivalency.utils';
import { ModuleContainer } from '../impact-modules.style';
import { StyledSVG, StyledText } from './energy-equivalency.style';

const getCopy = copyFor(
  'dashboard.standardDashboard.impactModules.energyEquivalency'
);

interface Props {
  vnmKwhCumulative?: number;
}

export const EnergyEquivalency = ({ vnmKwhCumulative }: Props) => {
  const equivalent = convertKwhToEquivalent(vnmKwhCumulative);
  const isEmptyState = !vnmKwhCumulative;
  const text = !isEmptyState
    ? getCopy('text', {
        equivalent: `${equivalent} day${equivalent === 1 ? '' : 's'}`,
      })
    : getCopy('emptyState');

  return (
    <ModuleContainer>
      <Container
        height="100%"
        flex
        justifyContent="space-between"
        alignItems="center"
        small={{
          alignItems: 'flex-start',
          direction: 'column-reverse',
          justifyContent: 'start',
          gap: '10px',
        }}
      >
        <StyledText color="secondary" textStyle="paragraph400">
          {text}
        </StyledText>
        <StyledSVG src={House} aria-hidden={true} />
      </Container>
    </ModuleContainer>
  );
};
